import { render, staticRenderFns } from "./InspectionAnomaly.vue?vue&type=template&id=6ba3ec7e&scoped=true&"
import script from "./InspectionAnomaly.vue?vue&type=script&lang=ts&"
export * from "./InspectionAnomaly.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionAnomaly.vue?vue&type=style&index=0&id=6ba3ec7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba3ec7e",
  null
  
)

export default component.exports